import { BlockOverrides } from 'baseui/block';

export const BLOCK: BlockOverrides = {
  Block: {
    style: {
      height: '100%',
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridTemplateRows: '1fr auto',
      marginTop: '16px',
      justifiyContent: 'center',
    },
  },
};

export const INNER: BlockOverrides = {
  Block: {
    style: {
      position: 'absolute',
      marginLeft: '24px',
      marginRight: '24px',
      width: 'calc(100% - 48px)',
      paddingBottom: '32px',
    },
  },
};
